(function(window) {
  const moneyFormatText =
    document.querySelector('.algolia-config-money-format')?.textContent?.toLowerCase() || '';
  const usesAmountNoDecimals = moneyFormatText.includes('amount_no_decimals');
  const usesAmountWithCommaSeparator = moneyFormatText.includes('amount_with_comma_separator');

  window.AlgoliaHelpers = {
    mergeTranslations: function (options) {
      const algolia = window.algoliaShopify;
      const algoliaTranslationsMetafieldEl = document.querySelector('[data-algolia-custom-translation-keys]');
      let algoliaCustomTranslationKeys = {};

      if (algoliaTranslationsMetafieldEl) {
        try {
          algoliaCustomTranslationKeys = JSON.parse(
            algoliaTranslationsMetafieldEl?.getAttribute('data-algolia-custom-translation-keys')
          );

          algolia.translations = {
            ...algolia.translations,
            ...algoliaCustomTranslationKeys,
          };

          if (algoliaCustomTranslationKeys.clear) {
            options.translations = {
              clearButtonTitle: algoliaCustomTranslationKeys.clear,
            };
          }
        } catch (e) {
          console.warn('Algolia custom translations keys are not valid JSON');
        }
      }
    },
    addTranslation: function (key, value) {
      const algolia = window.algoliaShopify;
      algolia.translations[key] = value;
    },
    // Transpiled into JavaScript code from "product-title.liquid" to replicate custom title logic in InstantSearch templates
    getBasicNetTitleParts: function (title) {
      if (!title || typeof title !== 'string') return '';

      const productTitleSplit = title.split(' - ');
      const productTitleFirst = productTitleSplit[0];
      const productTitleLast = productTitleSplit[productTitleSplit.length - 1];

      let finalTitle = title;

      if (productTitleSplit.length > 4) {
        let firstPart = productTitleFirst;

        // Caso speciale: "E - ONE LED"
        if (productTitleFirst === 'E' && productTitleSplit[1] === 'ONE LED') {
          firstPart = `${productTitleFirst}-${productTitleSplit[1]}`;
        }

        finalTitle = firstPart;
      }

      return {
        title: finalTitle,
        color: productTitleLast,
      };
    },
    getOmnibusPrice : function (item) {
      const omnibusRaw = item?.meta?.omnibus?.bestPrice;
      let itemOmnibus;

      if (omnibusRaw && typeof omnibusRaw === 'string') {
        itemOmnibus = JSON.parse(omnibusRaw);
      } else {
        itemOmnibus = omnibusRaw;
      }

      return itemOmnibus;
    },
    isOnSale : function (item) {
      const itemOmnibus = this.getOmnibusPrice(item);
      const variantMinPrice = item.variants_min_price;
      const variantCompareAtPriceMin = item.variants_compare_at_price_min;
      let fullPriceProduct = variantCompareAtPriceMin;

      if(itemOmnibus?.amount < fullPriceProduct){
        fullPriceProduct = itemOmnibus?.amount;
      }

      if (variantMinPrice < fullPriceProduct) {
        return true;
      } else {
        return false;
      }
    },
    isNewIn: function (item) {
      return item.tags?.includes('new_in');
    },
    doesItemPriceVary: function (item) {
      return item.variants_min_price !== item.variants_max_price;
    },
    addPriceVariesLabel: function (price) {
      const label = window
        .getComputedStyle(document.documentElement)
        .getPropertyValue('--aa-price-varies-label-content');
      return label.replace('{{ price }}', price);
    },
    wrapCurrency : function (formattedAmount) {
      return formattedAmount.replace(/([€$£¥₽₹])/g, '<span class="currency">$1</span>');
    },
    // Algolia does not support Shopify money format strings, so we post-process
    // based on the configured format read from the DOM.
    currencyFormattingAwarePrice: function (price) {
      if (usesAmountNoDecimals) {
        return price.replace(/([.,])00(?=\D*$)/, '');
      }
      if (usesAmountWithCommaSeparator) {
        return price.replace(/(\d)\.(\d{2})(?=\D*$)/, '$1,$2');
      }
      return price;
    },

    refreshAOS: function () {
      if (window.AOS) {
        requestAnimationFrame(() => {
          AOS.refreshHard();
        });
      }
    },

    scheduleAOSRefresh: function (timeout = 500) {
      setTimeout(() => {
        window.AlgoliaHelpers.refreshAOS();
      }, timeout);
    },

    onInstantSearch: function (event, callback) {
      const hitsContainer = document.querySelector('#algolia-shopify-instantsearch');
      if (!hitsContainer) return;

      const attach = (attempts = 0) => {
        const MAX_ATTEMPTS = 100;
        const is = algoliaShopify?.instantsearch?.search;

        if (is) {
          is.on(event, callback);
        } else if (attempts < MAX_ATTEMPTS) {
          requestAnimationFrame(() => attach(attempts + 1));
        } else {
          console.warn(
            `[Algolia] Could not attach listener for event "${event}": InstantSearch not available after max attempts`
          );
        }
      };

      attach();
    },

    getRelatedColorsConfig: function () {
      if (this._relatedColorsConfig !== undefined) return this._relatedColorsConfig;

      try {
        const configEl = document.getElementById('AlgoliaRelatedColorsConfig');
        this._relatedColorsConfig = configEl ? JSON.parse(configEl.textContent) : null;
      } catch (e) {
        console.warn('[Algolia] Related colors config is not valid JSON');
        this._relatedColorsConfig = null;
      }

      return this._relatedColorsConfig;
    },

    // Same data as product.metafields.related.related_products_json, indexed as meta.related.related_products_json
    getRelatedColors: function (hit) {
      const config = this.getRelatedColorsConfig();
      if (!config?.enabled) return null;

      let data = hit?.meta?.related?.related_products_json;
      if (typeof data === 'string') {
        try {
          data = JSON.parse(data);
        } catch (e) {
          return null;
        }
      }

      const relatedColors = data?.results_preview;
      if (!Array.isArray(relatedColors) || relatedColors.length === 0) return null;

      const count = data.total_count || relatedColors.length;
      if (count <= 0) return null;

      const current = relatedColors.filter((related) => related.handle === hit.handle);
      const others = relatedColors.filter((related) => related.handle !== hit.handle);

      return {
        config,
        count,
        hiddenCount: Math.max(count - config.maxVisible, 0),
        visible: current.concat(others).slice(0, config.maxVisible),
      };
    },

    // Mirrors the Liquid helpers used by plp-related-color-swatches.liquid
    relatedColorImageUrl: function (url) {
      if (!url || !url.includes('cdn.shopify.com') || url.includes('width=')) return url || '';
      return url + (url.includes('?') ? '&' : '?') + 'width=1000';
    },

    relatedColorHandle: function (handle) {
      return String(handle)
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
    },

    relatedColorTitle: function (related, config, fallback) {
      const title = related.title || {};
      return title[config.localeIsoCode] || title[config.localeCode] || title.en || fallback;
    },

    relatedColorSwatchBackground: function (related, config) {
      const colors = related.color_rbg || related.color_rgb;

      if (Array.isArray(colors) && colors.length > 0) {
        const limited = colors.slice(0, config.colorLimit);
        if (limited.length === 1) return limited[0];

        const stops = limited.map((color, index) => {
          const start = Math.floor((index * 100) / limited.length);
          const end = Math.floor(((index + 1) * 100) / limited.length);
          return `${color} ${start}%, ${color} ${end}%`;
        });
        return `linear-gradient(45deg, ${stops.join(', ')})`;
      }

      return related.color_family || '#f2f2f2';
    },

    // Hover image layers, rendered inside .grid-product__image-mask like `render_images: true`
    renderRelatedColorImages: function (hit, html) {
      const relatedColors = this.getRelatedColors(hit);
      if (!relatedColors) return '';

      return relatedColors.visible
        .filter((related) => related.handle && related.image)
        .map((related) => {
          const handle = this.relatedColorHandle(related.handle);
          return html`<div
            class="grid-product__color-image grid-product__color-image--${handle} plp-related-colors__image small--hide"
            style="background-image: url('${this.relatedColorImageUrl(related.image)}');"
          ></div>`;
        });
    },

    renderRelatedColorSwatches: function (hit, html, productUrl) {
      const relatedColors = this.getRelatedColors(hit);
      if (!relatedColors) return '';

      const { config, count, hiddenCount, visible } = relatedColors;
      const countLabel = `${count} ${count === 1 ? config.colorLabel : config.colorsLabel}`;

      return html`
        <div
          class="plp-related-colors plp-related-colors--${config.displayMode} plp-related-colors--mobile-${config.mobileDisplayMode}"
        >
          <div class="plp-related-colors__swatches" aria-label="${countLabel}">
            ${visible.map((related) => {
              const url = config.productsPath + related.handle;
              const hoverImage = config.hoverUseFirstImage
                ? related.image
                : related.secondImage || related.image;
              const title = this.relatedColorTitle(related, config, hit.title);

              return html`<a
                href="${url}"
                class="plp-related-colors__swatch${related.handle === hit.handle ? ' is-selected' : ''}"
                data-variant-id="${this.relatedColorHandle(related.handle)}"
                data-variant-image="${this.relatedColorImageUrl(related.image)}"
                data-hover-image="${this.relatedColorImageUrl(hoverImage)}"
                data-product-url="${url}"
                data-plp-related-color-swatch=""
                aria-label="${title}"
                style="background: ${this.relatedColorSwatchBackground(related, config)};"
              >
                <span class="visually-hidden">${title}</span>
              </a>`;
            })}
            ${hiddenCount > 0 &&
            html`<a
              href="${productUrl}"
              class="plp-related-colors__more"
              aria-label="${hiddenCount} ${config.colorsLabel} - ${hit.title}"
              >+${hiddenCount}</a
            >`}
          </div>
          <span class="plp-related-colors__count">${countLabel}</span>
        </div>
      `;
    },

    isQuickShopEnabled: function () {
      return Boolean(window.theme?.settings?.quickView && document.getElementById('QuickShopDrawer'));
    },

    // Same markup as the quick shop buttons in product-grid-item.liquid
    renderQuickShopButton: function (hit, html, modifier = '') {
      if (!this.isQuickShopEnabled()) return '';

      const label = this.getRelatedColorsConfig()?.quickShopText || '';

      return html`<button
        type="button"
        class="quick-product__btn ${modifier} quick-product__btn--not-ready js-drawer-open-quick-shop"
        aria-label="${label}"
        data-product-id="${hit.id}"
        data-product-handle="${hit.handle}"
      >
        <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-bag" viewBox="0 0 64 64">
          <g fill="none" stroke="currentColor" stroke-width="2">
            <path d="M25 26c0-15.79 3.57-20 8-20s8 4.21 8 20"></path>
            <path d="M14.74 18h36.51l3.59 36.73h-43.7z"></path>
          </g>
        </svg>
        <span class="visually-hidden">${label}</span>
      </button>`;
    },

    getQuickShopDrawer: function () {
      if (!window.theme.quickShopDrawer) {
        window.theme.quickShopDrawer = new window.theme.Drawers('QuickShopDrawer', 'quick-shop');
      }
      return window.theme.quickShopDrawer;
    },

    getProductBrand: function (hit) {
      const label = hit.meta?.basic_integration?.label_pim;
      const map = {
        'Kappa': 'KAPPA',
        'Authentic': 'KAPPA AUTHENTIC',
        'Robe di Kappa': 'ROBE DI KAPPA',
      };
      return map[label] || (label ? label.toUpperCase() : 'KAPPA');
    },

  };

  // theme.initQuickShop() only binds cards present on page load, while Algolia
  // renders its cards later (and the autocomplete default template is injected
  // as HTML), so quick shop buttons inside Algolia UIs are handled here.
  const QUICK_SHOP_SCOPE = '#algolia-shopify-instantsearch, .aa-Panel, .aa-DetachedOverlay';
  const QUICK_SHOP_BUTTON = '.js-drawer-open-quick-shop';
  const preloadedQuickShopHandles = new Set();

  const algoliaQuickShopButton = (target) => {
    const button = target.closest?.(QUICK_SHOP_BUTTON);
    return button && button.closest(QUICK_SHOP_SCOPE) ? button : null;
  };

  // Quick shop opened from the search shows above it, leaving the search open
  // underneath, so closing the drawer brings the user back to the same results.
  // The class raises the header, where the drawer lives, above the search (see
  // predictive-search.liquid).
  const OVER_SEARCH_CLASS = 'algolia-quick-shop-over-search';
  // Matches the drawer slide transition in theme.css
  const DRAWER_TRANSITION_DURATION = 250;

  const isQuickShopOverSearch = () => document.documentElement.classList.contains(OVER_SEARCH_CLASS);

  const closeSearch = () => {
    // The close button only removes the panel element: with a query typed,
    // autocomplete still thinks it is open and renders the panel again.
    // Escape closes it in its own state, keeping the query.
    document
      .querySelector('.aa-Input')
      ?.dispatchEvent(new KeyboardEvent('keydown', { key: 'Escape', bubbles: true }));
    document.querySelector('predictive-search .aa-CloseButton, .aa-DetachedCancelButton')?.click();
  };

  // Capture phase, so neither the hit or autocomplete item handlers nor the
  // drawer's outside click handler see the click
  document.addEventListener(
    'click',
    (event) => {
      const button = algoliaQuickShopButton(event.target);
      if (!button || !window.AlgoliaHelpers.isQuickShopEnabled()) return;

      event.preventDefault();
      // Immediate, to skip the outside click handler below as well
      event.stopImmediatePropagation();

      if (button.closest('.aa-Panel, .aa-DetachedOverlay')) {
        document.documentElement.classList.add(OVER_SEARCH_CLASS);
      }

      window.AlgoliaHelpers.getQuickShopDrawer().open(null, button);
    },
    true
  );

  // A click outside the drawer only closes it, without also acting on the
  // search results underneath
  document.addEventListener(
    'click',
    (event) => {
      if (!isQuickShopOverSearch() || event.target.closest('#QuickShopDrawer')) return;

      event.preventDefault();
      event.stopPropagation();
      window.AlgoliaHelpers.getQuickShopDrawer().close();
    },
    true
  );

  // Autocomplete closes on any mousedown or touchstart outside of it, as the
  // ones in the drawer, or outside it to close it, would be. The ones in the
  // drawer stop there, after its own handlers; the ones outside stop right
  // away, as they only close the drawer.
  const keepSearchOpen = (event) => {
    if (isQuickShopOverSearch()) event.stopPropagation();
  };
  const bindQuickShopDrawer = () => {
    const drawer = document.getElementById('QuickShopDrawer');
    drawer?.addEventListener('mousedown', keepSearchOpen);
    drawer?.addEventListener('touchstart', keepSearchOpen, { passive: true });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindQuickShopDrawer);
  } else {
    bindQuickShopDrawer();
  }

  ['mousedown', 'touchstart'].forEach((type) => {
    document.addEventListener(
      type,
      (event) => {
        if (!event.target.closest?.('#QuickShopDrawer')) keepSearchOpen(event);
      },
      { capture: true, passive: true }
    );
  });

  document.addEventListener('drawerClose.QuickShopDrawer', () => {
    if (!isQuickShopOverSearch()) return;

    // Keep the drawer above the search while it slides out
    window.setTimeout(() => {
      if (!window.AlgoliaHelpers.getQuickShopDrawer().isOpen) {
        document.documentElement.classList.remove(OVER_SEARCH_CLASS);
      }
    }, DRAWER_TRANSITION_DURATION);
  });

  // Adding to cart moves on to the cart drawer, which the search would cover
  document.addEventListener('ajaxProduct:added', () => {
    if (!isQuickShopOverSearch()) return;

    // Dropped first, or the outside click handler above would swallow the
    // clicks closing the search
    document.documentElement.classList.remove(OVER_SEARCH_CLASS);
    closeSearch();
  });

  // Preload the product on card hover, like the PLP cards do
  document.addEventListener('mouseover', (event) => {
    if (window.theme?.config?.bpSmall) return;

    const card = event.target.closest?.('.grid-product');
    if (!card || !card.closest(QUICK_SHOP_SCOPE)) return;

    const button = card.querySelector(QUICK_SHOP_BUTTON);
    const handle = button?.dataset.productHandle;
    if (!handle || preloadedQuickShopHandles.has(handle)) return;

    preloadedQuickShopHandles.add(handle);
    window.theme.preloadProductDrawer(handle, button.dataset.productId, button);
  });
})(window);
